import { fetcher } from 'util/Csrf'
import EnvVars from './EnvVars'

export const uploadFile = async (file: File) => {
  const body = new FormData()

  body.append('size', file.size.toString())
  body.append('name', file.name)
  body.append('file', file)

  const response = await fetcher(`${EnvVars.API_URL}/upload`, {
    method: 'POST',
    credentials: 'include',
    body,
  })

  return await response.text()
}
